<template>
    <div class="backtestmain">
        <div class="strategyquestion">
            <div class="question_main">
                <div class="question_title fl" v-click-outside="hideSearchList">
                    <div class="item-title">
                        <p class="normal fl">请输入您想要回测的问句：&nbsp&nbsp</p>
                        <p ref="sentenceNotice" class="highlight fl" style="display: none">策略问句不能为空且不能超过200字!</p>
                    </div>
                    <div class="item-input">
                        <input
                            ref="question_sentence_input"
                            id="question_sentence_input"
                            placeholder="请输入问句"
                            autocomplete="off"
                            v-model="sentence"
                            @blur="questionDataValidation($event, 0)"
                            @keyup="debounceQuestion($event, 1)"
                            @keyup.enter="startBacktest"
                            type="text"
                            v-validate="{ type: 'string', max: 200, min: 1, errClass: 'focus', errRef: 'sentenceNotice' }"
                            >
                        <span @click="empty"></span>
                        <key-list
                            v-if="searchVis"
                            :list-visible.sync="searchVis"
                            :list-data="searchList"
                            :max-num="7"
                            @click-item="updateInput"
                            @select-item="updateInput"
                            @no-checked="nochecked">
                        </key-list>
                    </div>
                </div>

                <div class="question_sentence fl" v-click-outside="hideBenchmarkList">
                    <div class="item-title">
                        <p class="normal fl">基准指数：&nbsp;&nbsp;</p>
                        <p class="highlight fl" ref="benchmarkNotice" style="display: none">标的不能为空！</p>
                    </div>
                    <div class="item-input" style="position: relative;">
                        <input
                            ref="question_benchmark"
                            type="text"
                            placeholder="请输入对应标的"
                            v-model.trim="benchmark"
                            @keyup="debounceBenchmark($event)"
                            @keyup.enter="startBacktest"
                            v-validate="{type: 'string', max: 50, min: 1, errClass:'focus', errRef: 'benchmarkNotice'}">

                        <key-list
                            v-if="benchmarkListVisible"
                            :list-visible.sync="benchmarkListVisible"
                            :list-data="benchmarkList"
                            :parse-item="parseItem"
                            value-key="label"
                            @click-item="updateBenchmarkInput"
                            @select-item="updateBenchmarkInput"
                            @no-checked="benchmarkNochecked">
                        </key-list>
                    </div>
                </div>

                <div class="question_cycle">
                    <p class="fl normal">输入您想回测的持股周期：&nbsp&nbsp</p>
                    <p class="fl highlight" ref="numberNotice" style="display: none">请正确输入正数，可用英文状态下&nbsp","&nbsp分隔天数</p>
                </div>
                <div class="question_cycle_number">
                    <input
                        ref="question_cycle_input"
                        type="text"
                        v-model="number"
                        @blur="questionCyclePoint"
                        @keyup="validateInput"
                        @keyup.enter="startBacktest"
                        v-validate="{ type: 'period', errClass: 'focus', errRef: 'numberNotice'}"
                        >
                    <span>&nbsp&nbsp天</span>
                </div>
                <div class="question_section">
                    <p class="fl">选择您想回测的时间区间：&nbsp&nbsp</p>
                </div>
                <div class="sd-toolbar">
                    <div class="sd-toolbar_operabox">
                        <input id="trade_detail_startDate" type="text" readonly="readonly" class="trade_detail_startDate" v-model="tradeStartDate" @click="showTradeDateDialog($event, '#F{$dp.$D(\'trade_detail_endDate\')}', '2014-1-1')" @blur="startDatePoint" @keyup.enter="startBacktest">
                        <span class="time-split">&nbsp;至&nbsp;</span>
                        <input id="trade_detail_endDate" type="text" readonly="readonly" class="trade_detail_endDate" v-model="tradeEndDate" @click="showTradeDateDialog($event, yesterdayDate, '#F{$dp.$D(\'trade_detail_startDate\')}')"  @blur="endDatePoint" @keyup.enter="startBacktest">
                    </div>
                </div>
                <div class="question_analysis" v-show="backtestCompleted">
                    <p class="fl">系统对您语句解析后，以下列条件进行回测</p>
                    <div class="condition" :title="condi" v-for="condi in conditions">{{ condi }}</div>
                </div>
                <div class="finish">
                    <p class="fl" v-show="backtestCompleted">回测运行完成 !</p>
                    <div class="savebacktest fl" v-show="backtestCompleted" @click="save" v-if="issave" >保存回测</div>
                    <div class="cancelbacktest fl" v-show="backtestCompleted" @click="cancel" v-if="!issave" @mouseenter="enter_1" @mouseleave="leave_1">{{ alreadysave }}</div>
                    <div v-if="!defaultqueryLoading" class="beginbacktest fr" @click="startBacktest">{{ buttonText }}</div>
                </div>
            </div>
        </div>
        <div class="report_grade" v-if="backtestCompleted">
            <div class="report_grade_title">
                <p>报告评级</p>
            </div>
            <div class="report_grade_main">
                <div class="history_happen">
                    <p>历史发生次数</p>
                    <p>{{ reportData.historyHappenCount }}次</p>
                </div>
                <div class="average_rise_fall">
                    <p>最优平均涨跌幅</p>
                    <p>回测持股周期 <span>{{ backtestData[reportData.maxAverageChangeRate[1]].daySaleStrategy }}</span> 天,平均涨跌幅 <span>{{ reportData.maxAverageChangeRate[0] | safePercentFixedTwo }}</span> </p>
                </div>
                <div class="max_win_rise">
                    <p>最大上涨概率</p>
                    <p>回测持股周期 <span>{{ backtestData[reportData.maxWinRate[1]].daySaleStrategy }}</span> 天,上涨概率 <span>{{ reportData.maxWinRate[0] | safePercentFixedTwo }}</span> </p>
                </div>
                <div class="report_grade_img" :class="reportData.level | levelType"></div>
            </div>
        </div>
        <div class="backtest_analysis" v-if="backtestCompleted">
            <div class="backtest_analysis_title">
                <p>回测分析
                    <vue-notice-tip :list="noticeList"></vue-notice-tip>
                </p>

            </div>
            <div class="backtest_analysis_main">
                <table cellspacing="0">
                    <thead>
                        <th width="21"></th>
                        <th width="58">持有期</th>
                        <th width="115">平均区间涨跌幅</th>
                        <th width="104">同期基准</th>
                        <th width="120">次日高开概率</th>
                        <th width="140">次日开盘平均涨跌幅</th>
                        <th width="102">最大涨跌幅</th>
                        <th width="103">最小涨跌幅</th>
                        <th width="79">盈亏比</th>
                        <th width="106">上涨概率</th>
                        <th width="130">基准上涨概率</th>
                    </thead>
                </table>
                <EasyScrollbar :barOption="myBarOption">
                    <div class="rolltable">
                        <table cellspacing="0">
                            <tbody>
                                <tr v-for="(back, index) in backtestData" :class="[(index + 1) % 2 === 0 ? 'gray' : '', index === reportData.maxWinRate[1] ? 'blue' : index === reportData.maxAverageChangeRate[1] ? 'blue' : '']">
                                    <td width="21" :class="index === reportData.maxWinRate[1] ? 'recommend' : index === reportData.maxAverageChangeRate[1] ? 'recommend' : 'transparent'">荐</td>
                                    <td width="58">{{ back.daySaleStrategy }}天</td>
                                    <td width="115">{{ back.averageChangeRate | safePercentFixedTwo }}</td>
                                    <td width="104">{{ back.hs300AverageIncome | safePercentFixedTwo}}</td>
                                    <td width="120">{{ back.highProbability | safePercentFixedTwo}}</td>
                                    <td width="140">{{ back.averageOpenIncome | safePercentFixedTwo}}</td>
                                    <td width="102">{{ back.maxChangeRate | safePercentFixedTwo }}</td>
                                    <td width="103">{{ back.minChangeRate | safePercentFixedTwo }}</td>
                                    <td width="79">{{ back.averageLossRatio | safeFloatFixedTwo }}</td>
                                    <td width="106">{{ back.winRate | safePercentFixedTwo }}</td>
                                    <td width="130">{{ back.hs300WinRate | safePercentFixedTwo }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </EasyScrollbar>
            </div>
        </div>
        <change-rate-group
            v-if="backtestCompleted"
            :dayselect="dayselect"
            :chartday="'' + backtestData[reportData.maxWinRate[1]].daySaleStrategy"
            :backtest-data="backtestData"
            :refresh="refresh"
            >
        </change-rate-group>

        <history-detail
            v-if="backtestCompleted"
            :dayselect="dayselect"
            :period="'' + backtestData[reportData.maxWinRate[1]].daySaleStrategy"
            :minDate="tradeStartDate"
            :maxDate="tradeEndDate"
            :myBarOption="myBarOption"
            :backtestId="backtestId"
            :refresh="refresh"
            >
        </history-detail>

        <div class="hotbacktest">
            <div class="hotbacktest_title">
                <p>热门回测</p>
            </div>
            <div class="hotbacktest_main">
                <div class="hotbacktest_left">
                    <div class="hotbacktest_name" v-for="leftback in lefthot">
                        <p :title="leftback.query">{{ leftback.query }}</p>
                        <span @click="buriedPoints"><router-link :to="{name: 'backtest', query: leftback.cond_data}">回测一下</router-link></span>
                    </div>
                </div>
                <div class="hotbacktest_right">
                    <div class="hotbacktest_name" v-for="rightback in righthot">
                        <p :title="rightback.query">{{ rightback.query }}</p>
                        <span @click="buriedPoints"><router-link :to="{name: 'backtest', query: rightback.cond_data}">回测一下</router-link></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="testmain" v-show="operateLoading">
            <div class="testshadow"></div>
            <div class="testparallel">
                <div class="test-loading">
                    <span class="testing-icon"></span>
                    <span>{{ loadingText }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable no-undef */
    /* eslint-disable no-new */
    import axios from 'axios'
    import changeRateGroup from './chart'
    import historyDetail from './history'
    import {showTradeDateDialog} from '@/lib/wDatePicker.js'
    import backtestBase from './backtest-base'
    import { debounce } from 'lodash'

    export default {
        name: 'backtest',
        mixins: [backtestBase],
        components: {
            'change-rate-group': changeRateGroup,
            'history-detail': historyDetail
        },
        data () {
            var yesDate = this._getNowDate()
            var self = this
            var debounceQuestion = debounce(function () {
                self.questionDataValidation(...arguments)
            }, 500)

            var debounceBenchmark = debounce(function () {
                self.benchmarkDataValidation(...arguments)
            }, 500)
            return {
                debounceQuestion,
                debounceBenchmark,
                benchmarkListVisible: false,
                myBarOption: {
                    // barColor: '#f60', // 滚动条颜色
                    barWidth: 9, // 滚动条宽度
                    // railColor: '#f5f5f5', // 导航颜色
                    barMarginRight: 3, // 垂直滚动条距离整个容器右侧距离单位
                    // barMarginBottom: 0, // 水平滚动条距离整个容器底部距离单位
                    // barOpacityMin: 0, // 滚动条非激活状态下的透明度
                    // zIndex: 'auto', // 滚动条的z-index
                    // autohidemode: true, // 自动隐藏模式
                    horizrailenabled: false // 是否显示水平滚动条
                },
                backtestId: '',
                backtestCompleted: false,
                operateLoading: false,
                tradeStartDate: '',
                tradeEndDate: '',
                benchmark: '399300 沪深300',
                sentence: '',
                number: '',
                yesterdayDate: yesDate,
                isintroduceshow: false,
                issave: true,
                loadingText: '正在为您计算，请耐心等待……',
                textPool: {
                    backtest: '正在为您计算，请耐心等待……',
                    save: '回测保存中……',
                    cancel: '回测取消保存中……'
                },
                alreadysave: '已保存',
                hotbacktest: [],
                conditions: [],
                reportData: {},
                backtestData: [],
                defaultParams: {},
                refresh: false,
                paramKeys: {
                    query: 'sentence',
                    daysForSaleStrategy: 'number',
                    startDate: 'tradeStartDate',
                    endDate: 'tradeEndDate',
                    benchmark: 'benchmark'
                },
                defaultqueryLoading: true,
                noticeList: ['1. 根据涨跌幅和上涨概率判断可以持有多久。', '2. 当上涨概率不高时，可以参考盈亏比。 ']
            }
        },
        computed: {
            benchmarkCode () {
                return this.benchmark.split(' ')[0]
            },
            hotbacktestList () {
                let list = []
                this.hotbacktest.forEach(item => {
                    list.push(item.query)
                })
                return list
            },
            lefthot () {
                return this.hotbacktest.slice(0, 3)
            },
            righthot () {
                return this.hotbacktest.slice(3, 6)
            },
            buriedPoint () {
                return this.$buriedPoint.backtestOnce
            },
            totalPoint () {
                return this.$buriedPoint.totalPlatformAccess
            },
            dayselect: function () {
                let arraySet = new Set(this.number.split(','))
                return Array.from(arraySet)
            },
            staticText () {
                return this.$staticText.backtest.index
            },
            showClear () {
                return this.sentence.length > 0
            },
            buttonText () {
                return this.operateLoading ? this.staticText.loadingButton : (this.backtestCompleted ? this.staticText.restartButton : this.staticText.beginButton)
            }
        },
        methods: {
            validateInput () {
                this.number = this.number.replace(/，/, ',')
            },
            standardDate (date) {
                if (date === undefined) {
                    return '--'
                }
                if (date.indexOf('-') < 0) {
                    return String(date).substring(0, 4) + '-' + String(date).substring(4, 6) + '-' + String(date).substring(6)
                }
                return date
            },
            buriedPoints () {
                window.TA.log({id: this.buriedPoint.hotBacktest, _sid: '__ths_003'})
            },
            startDatePoint () {
                window.TA.log(this.buriedPoint.strategyParam.startDate)
            },
            endDatePoint () {
                window.TA.log(this.buriedPoint.strategyParam.endDate)
            },
            questionCyclePoint () {
                window.TA.log(this.buriedPoint.strategyParam.holdingCycle)
            },
            questionDataValidation (event, num) {
                let val = event.target.value
                if (val === '') {
                    this.searchList = this.hotbacktestList
                    this.searchVis = true
                    return
                }
                if (this.sentence.length > 200) {
                    this.sentence = val.substr(0, 200)
                }
                if (num === 0) {
                    window.TA.log(this.buriedPoint.strategyParam.modifyQuestion)
                } else {
                    if (this.filterKey.indexOf(event.keyCode) > -1) {
                        return
                    }
                    let self = this
                    let lastStr = this.sentence[this.sentence.length - 1]
                    if (this.chunkSeparator.indexOf(lastStr) > -1) { // chunk
                        axios.get('/chunk/search?query=' + this.sentence)
                        .then((res) => {
                            if (res) {
                                if (res.data.errorcode === 0) {
                                    let list = []
                                    res.data.result.forEach(item => {
                                        list.push(self.sentence + item)
                                    })
                                    self.searchList = list
                                    self.searchVis = self.searchList.length !== 0
                                    self.defaultSentence = self.sentence
                                } else {
                                    self.searchVis = false
                                    self.searchList = []
                                }
                            }
                        }).catch((error) => {
                            self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                        })
                    } else {
                        axios.get('/chunk/searchdataextract?query=' + this.sentence)
                        .then((res) => {
                            if (res) {
                                if (res.data.errorcode === 0) {
                                    self.searchList = res.data.result
                                    self.searchVis = self.searchList.length !== 0
                                    self.defaultSentence = self.sentence
                                } else {
                                    self.searchVis = false
                                    self.searchList = []
                                }
                            }
                        }).catch((error) => {
                            self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                        })
                    }
                }
            },
            benchmarkDataValidation (event) {
                var self = this
                if (!this.benchmark) {
                    return false
                } else {
                    if (this.filterKey.indexOf(event.keyCode) > -1) {
                        return
                    }

                    this.requestSpellSearch().then((data) => {
                        this.benchmarkList = data.map(item => ({ ...item, label: this.parseItem(item) }))
                        if (this.benchmarkList.length === 0) {
                            this.benchmarkListVisible = false
                        } else {
                            this.benchmarkListVisible = true
                        }

                        this.defaultBenchmark = this.benchmark
                    }).catch(function (error) {
                        self.$tip({
                            message: error ? error.message : '网络异常',
                            duration: 2000,
                            type: 'error'
                        })
                    })
                }
            },
            parseItem (item) {
                return item.code + ' ' + item.name
            },
            hideBenchmarkList () {
                this.benchmarkListVisible = false
            },
            benchmarkNochecked () {
                this.benchmark = this.defaultBenchmark
            },
            updateBenchmarkInput (item) {
                this.benchmark = this.parseItem(item)
            },
            requestSpellSearch () {
                let spell = this.benchmarkCode
                return axios.get('/eventbacktest/spellsearch?query=' + spell).then((res) => {
                    return res.data.result
                })
            },
            _getNowDate: function () {
                var now = new Date()
                now.setDate(now.getDate() - 1) // 获取昨天时间
                var month = now.getMonth() + 1
                month = month < 10 ? '0' + month : month
                var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
                var nowDate = now.getFullYear() + '-' + month + '-' + date
                return nowDate
            },
            showTradeDateDialog,
            empty: function () {
                this.sentence = ''
                document.getElementById('question_sentence_input').focus()
            },
            enter_1: function () {
                this.alreadysave = '取消保存'
            },
            leave_1: function () {
                this.alreadysave = '已保存'
            },
            sortNumber (a, b) {
                return a - b
            },
            startBacktest: function () {
                if (this.searchVis) {
                    this.searchVis = false
                    return
                }

                if (this.benchmarkListVisible) {
                    this.benchmarkListVisible = false
                    return
                }

                var self = this
                this.$nextTick(() => {
                    if (!this.$refs.question_sentence_input.validate() ||
                        !this.$refs.question_benchmark.validate() ||
                        !this.$refs.question_cycle_input.validate()) {
                        return
                    }

                    window.TA.log(this.buriedPoint.strategyParam.startUpBacktest)

                    self.requestSpellSearch().then((data) => {
                        if (data.length === 0) {
                            self.$tip({
                                message: '基准指数错误',
                                duration: 2000,
                                type: 'error'
                            })
                        } else {
                            this.defaultBenchmark = this.parseItem(data[0])
                            this.benchmark = this.defaultBenchmark
                            let indexCode = data[0]['code']

                            self.operateLoading = true
                            let numberArry = Array.from(new Set(self.number.split(',').sort(self.sortNumber)))
                            self.number = numberArry.join(',')
                            axios.post('/backtestonce/backtest', {
                                query: self.sentence,
                                period: self.number,
                                start_date: self.tradeStartDate,
                                end_date: self.tradeEndDate,
                                benchmark: indexCode
                            }).then((res) => {
                                if (res.data.errorcode !== 0) {
                                    self.$tip({message: (res.data.errormsg ? res.data.errormsg : '网络异常'), duration: 2000, type: 'error'})
                                    self.operateLoading = false
                                    return false
                                }
                                if (res.data.result.isSaved) {
                                    self.issave = false
                                } else {
                                    self.issave = true
                                }
                                self.operateLoading = false
                                self.backtestId = res.data.result.id
                                if (self.backtestId === res.data.result.id) {
                                    self.refresh = !self.refresh
                                }
                                self.conditions = res.data.result.conditionData
                                self.reportData = res.data.result.reportData
                                self.backtestData = res.data.result.backtestData
                                self.backtestCompleted = true
                                location.hash = '#/backtest?query=' + encodeURIComponent(self.sentence) + '&daysForSaleStrategy=' + self.number + '&startDate=' + self.tradeStartDate + '&endDate=' + self.tradeEndDate + '&benchmark=' + encodeURIComponent(self.benchmark)
                            }).catch((error) => {
                                self.operateLoading = false
                                self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                            })
                        }
                    }).catch(function (error) {
                        self.$tip({
                            message: error ? error.message : '网络异常',
                            duration: 2000,
                            type: 'error'
                        })
                    })
                })
            },
            save: function () {
                window.TA.log(this.buriedPoint.backtestResult.save)
                if (this.operateLoading) {
                    return
                }
                this.loadingText = this.textPool.save
                this.operateLoading = true
                var self = this
                axios.post('/backtestonce/save', {
                    id: this.backtestId
                }).then((res) => {
                    self.$store.dispatch('myStrategy/requestBacktestOnce')
                    self.operateLoading = false
                    self.loadingText = self.textPool.backtest
                    if (res) {
                        if (res.data.errorcode === 0) {
                            this.issave = false
                        }
                    }
                }).catch((error) => {
                    self.operateLoading = false
                    self.loadingText = self.textPool.backtest
                    self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                })
            },
            cancel: function () {
                window.TA.log(this.buriedPoint.backtestResult.saveCancel)
                var self = this
                if (this.operateLoading) {
                    return
                }
                this.loadingText = this.textPool.cancel
                this.operateLoading = true

                axios.post('/backtestonce/cancelsave', {
                    id: this.backtestId
                }).then((res) => {
                    self.$store.dispatch('myStrategy/requestBacktestOnce')
                    self.operateLoading = false
                    self.loadingText = self.textPool.backtest
                    if (res) {
                        if (res.data.errorcode === 0) {
                            this.issave = true
                        }
                    }
                }).catch((error) => {
                    self.operateLoading = false
                    self.loadingText = self.textPool.backtest
                    self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                })
            },
            initParams () {
                if (this.defaultParams) {
                    this.sentence = this.defaultParams.query
                    this.tradeStartDate = this.defaultParams.startDate
                    this.tradeEndDate = this.defaultParams.endDate
                    this.number = this.defaultParams.daysForSaleStrategy
                    // todo 后台设置
                    this.benchmark = '399300 沪深300'
                } else {
                    this.sentence = ''
                    this.tradeStartDate = ''
                    this.tradeEndDate = ''
                    this.number = ''
                    this.benchmark = '399300 沪深300'
                }
            },
            startBacktestByRoute (routeParam) {
                var self = this
                var hasChanged = false
                for (let key in this.paramKeys) {
                    if (routeParam.hasOwnProperty(key) && routeParam[key] !== '' && self[self.paramKeys[key]] !== routeParam[key]) {
                        self[self.paramKeys[key]] = routeParam[key]
                        hasChanged = true
                    }
                }

                if (!self.backtestCompleted || hasChanged) {
                    this.startBacktest()
                }
            }
        },
        activated () {
            window.TA.log({id: this.buriedPoint.pageAccess, _sid: '__ths_001'})
            window.TA.log({id: this.totalPoint, _sid: '__ths_002'})
        },
        deactivated () {
            // 重置初始化状态
            this.backtestCompleted = false
            this.operateLoading = false
            this.isintroduceshow = false

            this.$refs.sentenceNotice.style.display = 'none'
            this.$refs.benchmarkNotice.style.display = 'none'
            this.$refs.numberNotice.style.display = 'none'

            this.$refs.question_sentence_input.className = ''
            this.$refs.question_benchmark.className = ''
            this.$refs.question_cycle_input.className = ''

            this.initParams()
        },
        mounted () {
            var self = this
            self.defaultqueryLoading = true
            axios.get('/backtestonce/defaultquery').then((res) => {
                self.defaultParams = res.data.result
                self.initParams()
                self.defaultqueryLoading = false
                if (JSON.stringify(self.$route.query) !== '{}') {
                    self.startBacktestByRoute(self.$route.query)
                }
            }).catch(function (error) {
                self.defaultqueryLoading = false
                self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
            })

            axios.get('/backtestonce/backtestexample?num=6').then((res) => {
                this.hotbacktest = res.data.result
            }).catch(function (error) {
                self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
            })
        },
        watch: {
            '$route' (newRoute, oldRoute) {
                if (this.defaultqueryLoading) {
                    return
                }
                if (newRoute.name === 'backtest') {
                    let params = newRoute.query
                    if (newRoute.name === oldRoute.name) {
                        this.startBacktestByRoute(params)
                    } else {
                        if (JSON.stringify(params) !== '{}') {
                            this.startBacktestByRoute(params)
                        }
                    }
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/backtest/main.scss';
</style>



// WEBPACK FOOTER //
// src/components/backtest/index.vue